<!--
    O palco tem a largura do card da prévia; a folha dentro dele é sempre 794 x 1123 (A4 a
    96dpi) e recebe um `zoom` para caber. É o que o modal do editor e a tela `cover-preview`
    já fazem, e é o único jeito de o fundo e o conteúdo escalarem juntos.
-->
<div class="cover-stage" #stage>
    @if (isLoading()) {
        <ra-loading />
    } @else {
        <div
            class="container-cover preview-cover-container"
            [style.zoom]="zoom()"
            [style.background-image]="imageBackground() ? 'url(' + imageBackground() + ')' : null"
            [style.background-size]="backgroundSize()"
            [style.background-position]="backgroundPosition()">
            @for (item of itemsCoverHtml(); track $index) {
                <div [innerHTML]="item"></div>
            }
        </div>
    }
</div>
